import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Tripboards} from '../../tripboard';
import {ErrorBoundary} from '../error-boundary';
import {getTranslations} from '../../selectors';
import PageView from '../PageView/PageView';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import {InviteAccept} from '../../tripboard/collaborate';
import {PAGE_TRIPBOARD_MAIN} from '../../utils/edap';
import {RecentActivityCarousel} from '../../recent-activity';
import {CreateTripboardButton} from '../../tripboard/create-tripboard-controls';
import {getIsMobile} from '../../selectors/system';
import './MainPageContainer.less';

function mapStateToProps(state, {location}) {
    const translations = getTranslations(state);
    const queryParams = queryString.parse(location.search);
    const favoritesMessage = translations['tripboards.favorites.message'];
    const errorTitle = translations['th.inbox.error.title'];
    const errorMessage = translations['th.inbox.error.message'];
    const showTripboardButton = state && state.tripboard && state.tripboard.createControls && state.tripboard.createControls.tripboardButtonVisible;
    return {
        errorTitle,
        errorMessage,
        title: translations['shared.bce.header.scratchpad.label'] || 'Scratchpad',
        favoritesMessage,
        fromFavorites: queryParams.redirect === 'favorites',
        pagename: PAGE_TRIPBOARD_MAIN,
        showTripboardButton,
        isMobile: getIsMobile(state),
        location
    };
}

export class MainPage extends Component {
    static propTypes = {
        errorTitle: PropTypes.string,
        errorMessage: PropTypes.string,
        fromFavorites: PropTypes.bool,
        favoritesMessage: PropTypes.string,
        title: PropTypes.string
    }

    static defaultProps = {
        fromFavorites: false,
        location: {search: ''}
    }

    constructor(props) {
        super(props);
    }

    render() {
        const {errorTitle, errorMessage, fromFavorites, favoritesMessage, showTripboardButton, isMobile} = this.props;

        return (
            <div id="main-page-container" className="main-page-container">
                <PageView pagename={PAGE_TRIPBOARD_MAIN} />
                <ErrorBoundary errorTitle={errorTitle} errorMessage={errorMessage}>
                    <InviteAccept />
                    <div className="row">
                        <div className="col-sm-10 col-sm-offset-1">
                            <div className="main-page-container__header">
                                {fromFavorites &&
                                    <div>
                                        <div className="fade in alert alert--verbose alert-info" role="alert">
                                            <svg className="inline-svg" aria-hidden="true">
                                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-clock" />
                                            </svg>
                                            <div className="scratchpad-alert-message-text">
                                                <p>{favoritesMessage}</p>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {showTripboardButton &&
                                    <div className="tripboard-summary__row">
                                        <h2 data-wdio="tripboard-summary__header">{this.props.title}</h2>
                                        <div className="tripboard-summary__createButton">
                                            <CreateTripboardButton isMobile={isMobile}/>
                                        </div>
                                    </div>
                                }
                                {!showTripboardButton && <h2 data-wdio="tripboard-summary__header">{this.props.title}</h2>}

                            </div>
                            <Tripboards/>
                        </div>
                    </div>
                    <div className="row">
                        <RecentActivityCarousel />
                    </div>
                </ErrorBoundary>
            </div>
        );
    }
}

export default connect(mapStateToProps)(MainPage);



// WEBPACK FOOTER //
// ./src/universal/components/MainPage/MainPageContainer.js